import Cookies from "js-cookie";

const COOKIE_DOMAIN = "." + process.env.REACT_APP_BASE_DOMAIN_NEW;

// All storage keys used by the app. AUTH / AUTH_CUSTOMER are cookies (shared across
// subdomains); WEBSITE is a per-host localStorage cache (use CacheGetItem/CacheSetItem).
export const STORAGE_KEYS = {
    AUTH: "EFL-Auth-Data",
    AUTH_CUSTOMER: "EFL-Auth-Customer-Data",
    WEBSITE: "EFL-Website-Data",
};

// Keys from before the rename, deleted on app start.
export const LEGACY_COOKIE_KEYS = ["bookAuthData", "bookAuthCustomertData", "EFL-Domain-Data-New", "homeConfigData"];

export const StorageGetItem = (key) => {
    const raw = Cookies.get(key);
    if (!raw) return null;

    let result;
    try {
        result = JSON.parse(raw);
    } catch {
        Cookies.remove(key, { domain: COOKIE_DOMAIN, path: "/" });
        return null;
    }

    if (result.expireTime && result.expireTime <= Date.now()) {
        Cookies.remove(key, { domain: COOKIE_DOMAIN, path: "/" });
        return null;
    }
    return result.data;
};

export const StorageSetItem = (key, value, maxAge = 24 * 60 * 60 * 1000) => {
    const result = { data: value };
    if (maxAge) {
        result.expireTime = Date.now() + maxAge;
    }

    const str = JSON.stringify(result);

    Cookies.set(key, JSON.stringify(result), {
        domain: COOKIE_DOMAIN,
        path: "/",
        expires: maxAge / (24 * 60 * 60 * 1000), // js-cookie wants days, not ms
        sameSite: "lax",
        secure: window.location.protocol === "https:",
    });
};

export const StorageRemoveItem = (key) => {
    Cookies.remove(key, { domain: COOKIE_DOMAIN, path: "/" });
};

// Per-host cache in localStorage, for data too large for a cookie (e.g. website/template config).
// Every access is guarded: Safari private mode / blocked storage can throw.
export const CacheGetItem = (key) => {
    try {
        const raw = window.localStorage.getItem(key);
        if (!raw) return null;

        const result = JSON.parse(raw);
        if (result.expireTime && result.expireTime <= Date.now()) {
            window.localStorage.removeItem(key);
            return null;
        }
        return result.data;
    } catch {
        return null;
    }
};

export const CacheSetItem = (key, value, maxAge = 15 * 60 * 1000) => {
    try {
        const result = { data: value };
        if (maxAge) {
            result.expireTime = Date.now() + maxAge;
        }
        window.localStorage.setItem(key, JSON.stringify(result));
    } catch {
        // storage unavailable -> skip caching
    }
};

export const CacheRemoveItem = (key) => {
    try {
        window.localStorage.removeItem(key);
    } catch {
        // storage unavailable
    }
};